import { Node, mergeAttributes } from '@tiptap/core';
import { canonicalTemplateVariableText } from '@mts/shared/templateVariables';

const TemplateVariable = Node.create({
  name: 'templateVariable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  addAttributes: () => ({
    object: { default: null, rendered: false },
    property: { default: null, rendered: false },
    key: { default: null, rendered: false },
    label: { default: null, rendered: false },
    fallback: { default: null, rendered: false },
    missingPolicy: { default: 'blank', rendered: false },
    format: { default: null, rendered: false },
    version: { default: 1, rendered: false },
    renderedValue: { default: null, rendered: false },
  }),
  parseHTML: () => [{
    tag: 'span[data-template-variable]',
    getAttrs: (element) => {
      const key = element.getAttribute('data-template-variable') || '';
      const [object, property] = key.split('.');
      let format = null;
      try {
        format = JSON.parse(element.getAttribute('data-template-variable-format') || 'null');
      } catch {
        format = null;
      }
      return {
        object,
        property,
        key,
        label: element.getAttribute('data-template-variable-label') || null,
        fallback: element.getAttribute('data-template-variable-fallback'),
        missingPolicy: element.getAttribute('data-missing-policy') || 'blank',
        format,
        version: Number(element.getAttribute('data-template-variable-version')) || 1,
      };
    },
  }],
  renderHTML: ({ node, HTMLAttributes }) => ['span', mergeAttributes(HTMLAttributes, {
    'data-template-variable': node.attrs.key,
    'data-template-variable-label': node.attrs.label,
    'data-template-variable-fallback': node.attrs.fallback,
    'data-template-variable-format': JSON.stringify(node.attrs.format),
    'data-template-variable-version': node.attrs.version,
    'data-missing-policy': node.attrs.missingPolicy,
    class: 'template-variable-chip',
    title: canonicalTemplateVariableText(node.attrs),
  }), node.attrs.renderedValue || node.attrs.label || node.attrs.key],
  renderText: ({ node }) => node.attrs.renderedValue || canonicalTemplateVariableText(node.attrs),
  addCommands() {
    return {
      insertTemplateVariable: (attrs) => ({ commands }) => commands.insertContent({
        type: this.name,
        attrs: { ...attrs, version: 1 },
      }),
      updateTemplateVariable: (attrs) => ({ commands }) => commands.updateAttributes(this.name, attrs),
      removeTemplateVariable: () => ({ commands }) => commands.deleteSelection(),
    };
  },
});

export default TemplateVariable;
export { TemplateVariable };
